import { init } from './init'
import './styles/01-variables.css'
import './styles/02-reset.css'
import './styles/03-base.css'
import './styles/04-prose.css'
import './styles/form.css'
import './styles/popup.css'
import './styles/tags.css'
import './styles/vacancies.css'
import './styles/vacancy.css'

declare global {
  interface Window {
    vbzCockpit: {
      init: typeof init
      refresh: typeof init
    }
  }
}

window.vbzCockpit = { init, refresh: init }

if (document.readyState === 'complete') {
  init()
} else {
  window.addEventListener('load', init)
}
